/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import Cookies from 'js-cookie';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import api from 'api';
import PartnersData from 'utils/corporateSettings.json';
import { ImDownload3 } from 'react-icons/im';
import { Header, SideMenu, Button, Dialog, Select } from 'components';
import { Container, ContentArea, Title, Div, ModalButton, DivPicker } from './styles';
import { toast } from 'react-toastify';
import { white } from 'styles/colorProvider';
import { Alert } from '@material-ui/lab';
import 'moment/locale/pt-br';

const MAX_DAYS = 31;

function ExportAccountingBranch() {
  const [exportData, setExportData] = useState();
  const [openExport, setOpenExport] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [partnerId, setPartnerId] = useState('');
  const [loadingExport, setLoadingExport] = useState(false);
  const [exportErrorMessage, setExportErrorMessage] = useState('');

  const handleCloseDialog = () => {
    if (!loadingExport) {
      setOpenExport(false);
      setExportErrorMessage('');
      setExportData();
    }
  };

  const renderExportDialog = () => (
    <Dialog
      open={openExport}
      onClose={handleCloseDialog}
      width="50%"
      height="100px"
      title="Exportar relatório Ramo Contábil"
    >
      {!exportData && (
        <>
          <div style={{ width: '100%' }}>
            <DivPicker>
              <p>Data inicial</p>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  emptyLabel="DD/MM/AAAA"
                  value={startDate}
                  onChange={setStartDate}
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  invalidDateMessage="Data inválida"
                  style={{ width: '100%' }}
                />
              </MuiPickersUtilsProvider>
            </DivPicker>
            <DivPicker>
              <p>Data final</p>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  emptyLabel="DD/MM/AAAA"
                  value={endDate}
                  onChange={setEndDate}
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  invalidDateMessage="Data inválida"
                  style={{ width: '100%' }}
                />
              </MuiPickersUtilsProvider>
            </DivPicker>
            <Select
              label="Parceiro (opcional)"
              height="35px"
              value={partnerId}
              onChange={(e) => setPartnerId(e.target.value)}
            >
              <option value="">Todos os parceiros</option>
              {PartnersData?.map((partner) => (
                <option key={partner.id_partner} value={partner.id_partner}>
                  {partner.name}
                </option>
              ))}
            </Select>
          </div>
          {exportErrorMessage && (
            <Alert severity="error" style={{ width: '90%', height: '30px', marginTop: '15px' }}>
              {exportErrorMessage}
            </Alert>
          )}
          <ModalButton>
            <Button
              height="35px"
              style={{ margin: '2rem 0 0 0' }}
              onClick={handleExport}
              disabled={loadingExport}
            >
              {loadingExport ? (
                <ReactLoading color={white} height={25} width={25} type="spin" />
              ) : (
                'Exportar'
              )}
            </Button>
          </ModalButton>
        </>
      )}

      {exportData?.url && (
        <>
          <p>Seu arquivo está pronto!</p>
          <p>
            <a href={exportData.url} target="_blank" rel="noreferrer">
              Clique aqui para baixar
            </a>
          </p>
        </>
      )}
    </Dialog>
  );

  const handleExport = async () => {
    setLoadingExport(true);
    setExportErrorMessage('');

    if (!startDate || !endDate) {
      setExportErrorMessage('Informe a data inicial e a data final.');
      setLoadingExport(false);
      return;
    }

    const start = moment(startDate);
    const end = moment(endDate);
    if (end.isBefore(start)) {
      setExportErrorMessage('Data final deve ser maior ou igual à inicial.');
      setLoadingExport(false);
      return;
    }
    if (end.diff(start, 'days') > MAX_DAYS) {
      setExportErrorMessage(`O período não pode ultrapassar ${MAX_DAYS} dias.`);
      setLoadingExport(false);
      return;
    }

    try {
      const params = {
        startDate: start.format('YYYY-MM-DD'),
        endDate: end.format('YYYY-MM-DD'),
      };
      if (partnerId) params.partner = String(partnerId);

      const { data } = await api({
        method: 'GET',
        url: '/reports/accounting-branch-report',
        params,
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          feature: 'accounting-branch-report',
        },
      });
      setExportData(data);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Não foi possível exportar o relatório.',
        { position: toast.POSITION.TOP_RIGHT, theme: 'colored' }
      );
      handleCloseDialog();
    }
    setLoadingExport(false);
  };

  return (
    <>
      {renderExportDialog()}
      <Header />
      <Container>
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>Ramo Contábil</Title>
          </Div>
          <Button width="280px" onClick={() => setOpenExport(true)} disabled={loadingExport}>
            {loadingExport ? (
              <ReactLoading color="#fff" height={25} width={25} type="spin" />
            ) : (
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ImDownload3 style={{ marginRight: 5 }} /> Baixar relatório
              </span>
            )}
          </Button>
        </ContentArea>
      </Container>
    </>
  );
}

export default ExportAccountingBranch;
